import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { EmailShareButton, FacebookMessengerShareButton, FacebookShareButton } from "react-share";
import moment from "moment";
import { Modal } from "react-bootstrap";

import { commonErr } from "../common/errors";

import { MessageBox } from "../common/messagebox";
import {
	IcCopyGreen,
	IcQuesMark,
	IcZaloSharedCode,
	IcGmailSharedCode,
	IcMessSharedCode,
	IcFaceBookSharedCode,
	IcQuestionWhite,
} from "../common/svg";

import sharecode_popup from "../../static/images/reward-noti/banner.png";

const ShareCodeDetail = ({ show, onHide, timeBefore30Days, isShareCode }) => {
	return (
		<Modal show={show} onHide={onHide} dialogClassName="modal-m modal-fix modal-text">
			<Modal.Header closeButton={true} closeLabel={""}></Modal.Header>
			<Modal.Body>
				<div className="modal-text-body reward-noti-body">
					<img loading="lazy" className="main-img" src={sharecode_popup} />
					{!isShareCode && (
						<div className="block-bg">
							<p className="font-14 text-danger">
								Chương trình chỉ áp dụng cho thành viên đã có chuyến hoặc có thời gian đăng kí tài khoản trước{" "}
								{moment(timeBefore30Days).format("L")}.
							</p>
						</div>
					)}
					<h5 className="textAlign-center">Chương trình giới thiệu Mioto đến bạn bè</h5>
					<div className="block-content">
						<p>✨ Bạn đang sử dụng và hài lòng với trải nghiệm trên Mioto?</p>
						<p>✨ Bạn sẵn lòng chia sẻ/giới thiệu Mioto đến nhiều bạn bè của mình?</p>
						<p>
							👉 Trải nghiệm ngay tính năng GIỚI THIỆU BẠN MỚI để nhận quà tặng 500k từ Mioto. (chỉ áp dụng cho dịch vụ
							thuê xe tự lái)
						</p>
					</div>
					<div className="block-bg-nd">
						<div className="block-content">
							<b>BẠN MÌNH (NGƯỜI ĐƯỢC GIỚI THIỆU) nhận:</b>
							<p>💵 Mã khuyến mãi thuê xe 200,000 cho chuyến đầu tiên trên Mioto.</p>
						</div>
						<div className="block-content">
							<b>MÌNH (NGƯỜI GIỚI THIỆU) nhận:</b>
							<p>
								🎁 500 điểm thưởng tương đương 500,000đ khi "bạn mình" hoàn thành chuyến đầu tiên. Bạn có thể đổi ra Thẻ
								quà Got-it (thẻ cào, vé xem phim, café, thẻ siêu thị) hoặc Mã giảm giá thuê xe Mioto.
							</p>
							<p>
								👉 Lưu ý:
								<br />
								Chương trình chỉ áp dụng cho đơn hàng Thuê xe Tự lái có tổng giá trị từ 1,000,000đ (giá trước khuyến
								mãi)
							</p>
						</div>
					</div>
					<b>Hướng dẫn sử dụng </b>
					<div className="block-content">
						<p>
							👉 Người giới thiệu: Sao chép nội dung giới thiệu, sau đó chia sẻ trên các nền tảng xã hội như Facebook,
							Zalo, ứng dụng tin nhắn…
						</p>
						<p>👉 Người được giới thiệu:</p>
						<p>+ Click vào liên kết giới thiệu để tải và cài ứng dụng Mioto.</p>
						<p>+ Nhập mã giới thiệu vào mục “Mã khuyến mãi” khi thực hiện đặt xe.</p>
					</div>
					<div className="block-content">
						<p>Vd: Ứng với liên kết giới thiệu để cài ứng dụng là:</p>
						<p>http://l.mioto.vn/instl/MGTABC thì sẽ nhập mã khuyến mãi khi đặt xe là mã giới thiệu MGTABC.</p>
					</div>
					<p>✨ Hy vọng bạn luôn có những trải nghiệm thật vui cùng Mioto!</p>
					<p>Xin chân thành cám ơn </p>
					<strong>Mioto Team</strong>
				</div>
			</Modal.Body>
		</Modal>
	);
};

const ShareCode = (props) => {
	const [copied, setCopied] = useState(false);
	const [showDetail, setShowDetail] = useState(false);

	const toggleCopyBox = () => {
		setCopied(!copied);
	};

	const togglePopup = () => {
		setShowDetail(!showDetail);
	};

	const { info } = props.profile;

	const totalTripsOwner = props.profileDetail.owner.totalTrips;
	const totalTripsTraveler = props.profileDetail.traveler.totalTrips;
	const timeCreated = props.profileDetail.timeCreated;

	const timeCreatedToPresent = moment().valueOf() - timeCreated > 7776000000;
	const timeBefore30Days = moment().valueOf() - 7776000000;

	const isShareCode = timeCreatedToPresent || totalTripsOwner > 0 || totalTripsTraveler > 0;
	const TEXT_SHAREDCODE = `Nhập mã ${info?.shareCode} của ${info?.name} để được giảm ngay 200,000 khi thuê xe chuyến đầu tiên trên Mioto. Đặt xe ngay ${info?.shareCodeUrl}`;

	return (
		<div className="content-item share-code">
			<div className="main-content">
				<div className="title">
					<h5>Giới thiệu bạn mới </h5>
					<div className="learn-more">
						<p>Tìm hiểu chi tiết chương trình</p>
						<div className="wrap-svg" onClick={togglePopup}>
							<IcQuesMark />
						</div>
					</div>
				</div>
				{info?.shareCode && isShareCode && (
					<div className="content">
						<div className="code">
							<p>{info.shareCode}</p>
							<div className="line-code"> </div>
							<CopyToClipboard text={TEXT_SHAREDCODE} onCopy={toggleCopyBox}>
								<div className="wrap-svg">
									<IcCopyGreen />
								</div>
							</CopyToClipboard>
						</div>
						<div className="share-social">
							Chia sẻ
							<FacebookShareButton
								style={{ marginRight: "5px" }}
								url={info.shareCodeUrl}
								hashtag={"#MIOTO"}
								quote={TEXT_SHAREDCODE}
								children={
									<div className="wrapper-media">
										<IcFaceBookSharedCode />
									</div>
								}
							/>
							<FacebookMessengerShareButton
								style={{ marginRight: "5px" }}
								appId="1760356927595709"
								url={info.shareCodeUrl}
								children={
									<div className="wrapper-media">
										<IcMessSharedCode />
									</div>
								}
							/>
							<EmailShareButton
								url={info.shareCodeUrl}
								body={TEXT_SHAREDCODE}
								subject={`Mã khuyến mãi MIOTO giảm 200.000đ`}
								children={
									<div className="wrapper-media">
										<IcGmailSharedCode />
									</div>
								}
							/>
						</div>
					</div>
				)}
			</div>
			<div className="content-img pointer" onClick={togglePopup}>
				<img src={sharecode_popup} />
			</div>
			<ShareCodeDetail
				timeBefore30Days={timeBefore30Days}
				isShareCode={isShareCode}
				show={showDetail}
				onHide={togglePopup}
			/>
			<MessageBox
				error={commonErr.SUCCESS}
				show={copied}
				hideModal={toggleCopyBox}
				message="Đã sao chép mã giảm giá vào bộ nhớ. Hãy chia sẻ ngay với bạn bè của mình."
			/>
		</div>
	);
};

export default ShareCode;
